export const ENTITIES = '@@EMPLOYEE/ENTITIES';

export enum LIST {
  REQUEST = '@@EMPLOYEE/LIST/REQUEST',
  SUCCESS = '@@EMPLOYEE/LIST/SUCCESS',
  FAILURE = '@@EMPLOYEE/LIST/FAILURE'
}
